import register from "highlight.js/lib/languages/rsl";

export const rsl = { name: "rsl", register };
export default rsl;
